// 简单的哈希函数，用于生成数据签名
// 注意：生产环境应使用更安全的加密算法和后端生成的签名
export function generateHash(data) {
  // 将数据转换为字符串
  const str = JSON.stringify(data);
  let hash = 0;
  if (str.length === 0) return hash;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convert to 32bit integer
  }
  return Math.abs(hash).toString(16);
}

// 验证数据完整性
export function verifyDataIntegrity(data, expectedHash) {
  const actualHash = generateHash(data);
  return actualHash === expectedHash;
}